export default "__VITE_ASSET__dec50c05__"